/**
 * roleSwitchApi.js
 * Utility functions for role-switch API calls.
 * Drop into your existing utils/ folder.
 */

import api from "./api";

// const getAuthHeaders = () => ({
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// });

// ── Switch to an already-registered role ─────────────────────────────────────

/**
 * Instantly switch to a role the user already owns.
 * @param {"student"|"tutor"|"institution"} targetRole
 * @returns {Promise<{ message: string, user: object }>}
 */
export const switchRole = async (targetRole) => {
  const res = await api.post("/users/role-switch", { targetRole });
  return res.data; // axios already parses JSON, no .json() needed
};

// ── Request a new role ────────────────────────────────────────────────────────

/**
 * Submit a request to add a brand-new role (requires admin approval).
 * @param {"student"|"tutor"|"institution"} requestedRole
 * @param {object} [details] - role-specific fields (e.g. academyName for institution)
 * @returns {Promise<{ message: string, roleSwitchRequest: object }>}
 */
export const requestRoleSwitch = async (requestedRole, details) => {
  const res = await api.post("/users/role-switch/request", {
    requestedRole,
    details,
  });
  return res.data;
};


// ── Get current role switch status ───────────────────────────────────────────

/**
 * Fetch the user's current role, available roles, and any pending request.
 * @returns {Promise<{ currentRole: string, availableRoles: string[], roleSwitchRequest: object|null }>}
 */

export const getRoleSwitchStatus = async () => {
  const res = await api.get("/users/role-switch/status");
  return res.data;
};
